module.exports = __webpack_public_path__ + "img/list_no_content.ae219ede.png";